import { sortableFieldsMapper } from 'components/Table/helpers';
import { ITableRowConfig, SortDirection } from 'components/Table/types';
import { sortTableRows } from 'utils/sortTableRows';
import { columnKeyMap } from './constants';

export interface IFormattedBOMItem {
  id: string;
  description: string;
  length: string;
  quantity_per: string;
  unit: string;
  routing_link_code: string;
  not_sell_before?: string;
  not_sell_after?: string;
}

export const formatBomItems = (bomItems: object): IFormattedBOMItem[] => {
  if (!bomItems) {
    return [];
  }

  const formattedBomItems: IFormattedBOMItem[] = [];
  for (const bomItemKey of Object.keys(bomItems)) {
    const initialBomItem = bomItems[bomItemKey];
    if (initialBomItem.hidden || !initialBomItem.id) {
      continue;
    }

    const formattedBomItem: IFormattedBOMItem = {
      id: initialBomItem.id,
      description: initialBomItem.description,
      length: initialBomItem.cutting_length,
      quantity_per: initialBomItem.quantity_per,
      unit: initialBomItem.unit,
      routing_link_code: initialBomItem.routing_link_code,
      not_sell_before: initialBomItem.notbefore,
      not_sell_after: initialBomItem.notafter,
    };

    formattedBomItems.push(formattedBomItem);
  }

  return formattedBomItems;
};

// sortBy holds whatever sortableFieldsMapper derived from the column header,
// which for most BOM columns is not the row key (Article number sorts as
// article_number, the row holds id), so it is mapped back through the header.
// Only the given columns are looked at, so a sort on a column the user has
// since hidden stops ordering the rows.
export const sortBomItems = (
  bomItems: IFormattedBOMItem[],
  sortBy: string,
  sortDirection: SortDirection | undefined,
  rowConfigs: ITableRowConfig[]
): IFormattedBOMItem[] => {
  const sortedColumn = rowConfigs.find(
    (rowConfig: ITableRowConfig) => sortableFieldsMapper(rowConfig) === sortBy
  );

  return sortTableRows(
    bomItems,
    sortedColumn
      ? (columnKeyMap[sortedColumn.header] as keyof IFormattedBOMItem)
      : undefined,
    sortDirection
  );
};
